export const sharedNextPage = (page, params, history) => {
    try {
        // const history = useHistory();
        // history.push(`${page}`);
        // console.log('params');
        // console.log(params);
        if (params !== undefined && params !== null) {
            if (params.acciones !== undefined) {
                delete params.acciones;
            }
            // console.log('params sin acciones');
            // console.log(params);
            history.push({
                pathname: `${page}`,
                state: params
            });
        } else {
            history.push(`${page}`);
        }
    } catch (err) {
        console.log('nextPage err');
        console.log(err);
    }
};

export const compressAndConvertToBase64 = (file, callback) => {
    const reader = new FileReader();

    reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            // Set target width/height (optional resizing)
            const maxWidth = 1024; // adjust as needed
            const scaleSize = maxWidth / img.width;
            canvas.width = maxWidth;
            canvas.height = img.height * scaleSize;

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Compress and convert to Base64
            const compressedBase64 = canvas.toDataURL("image/jpeg", 0.7); // 0.7 = 70% quality
            const base64String = compressedBase64.split(",")[1];

            callback(base64String);
        };

        img.onerror = (err) => {
            console.error("Image load error:", err);
        };
    };

    reader.readAsDataURL(file);
};